import * as React from "react";
import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Input, InputProps, Label, makeStyles, Text, tokens } from "@fluentui/react-components";
import { getBestOffers, makeOffer } from "../services/AuctionService";
import { IBestOffer } from "../models/offer";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";

export const ResetPassword = () => {
  

  return (
    <div className="container">
      Reset Password
    </div>
  );
};